import Auth from "@aws-amplify/auth";

const useAuth = {
    methods: {
        async onSignOut() {
            await Auth.signOut();
            this.$router.replace("/auth", (err) => {
                console.log(err, "ignored");
            });
        },
    },
};

export default useAuth;